/* Этот файл сгенерирован автоматически на основe шаблона exportService.hbs */
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetPropertiesRequest } from '../models';
import type { SegmentProperty } from '../models';
import { request } from 'api/apiRouter';
import type { ApiRequestOptions, ApiResponse } from '@web-chat-core/toolkit/src/api3';
export class RemotePropertiesControllerService {
    public static getProperties(
        requestBody: GetPropertiesRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<Array<SegmentProperty>>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/remote-properties/getProperties',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
}
